import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_sofort",
  "use": "svg_sofort-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"svg_sofort\"><path d=\"M14.383 41.014v37.242H28.63V41.014H14.383Zm28.494 0v37.242h14.246V41.014H42.877ZM-.114 100h100.229V85.754H-.114V100Zm71.485-58.986v37.242h14.246V41.014H71.371ZM50 .274-.114 24.019v9.497h100.229v-9.497L50 .274Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol